import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "../Layouts/MainLayout";
import Home from "../Pages/Home/Home";
import About from "../Pages/About/About";
import OurServices from "../Pages/OurServices/OurServices";
import Insights from "../Pages/Insights/Insights";
import FAQs from "../Pages/FAQs/FAQs";


import Care_Home from "../Sub-Pages/Care_Home";
import CQC_Services from "../Sub-Pages/CQC_Services";
import Capital_Allowance from "../Sub-Pages/Capital_Allowance";
import Accounting from "../Sub-Pages/Accounting";
import Software from "../Sub-Pages/Software";
import Operational_Management from "../Sub-Pages/Operational_Management";
import Registration from "../Pages/Registration/Registration";


import Blog_Registration from "../Blogs-Pages/Blog_Registration";
import Blog_CompGuide from "../Blogs-Pages/Blog_CompGuide";
import Blog_Beginners from "../Blogs-Pages/Blog_Beginners";
import Blog_Business from "../Blogs-Pages/Blog_Business";
import Blog_Compliance from "../Blogs-Pages/Blog_Compliance";
import Blog_DocNeeded from "../Blogs-Pages/Blog_DocNeeded";
import Blog_GuideSteps from "../Blogs-Pages/Blog_GuideSteps";
import Blog_RegManager from "../Blogs-Pages/Blog_RegManager";
import Blog_RegTake from "../Blogs-Pages/Blog_RegTake";
import Blog_Capital from "../Blogs-Pages/Blog_Capital_Allowance";








function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/*  Home pages */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<OurServices />} />
          <Route path="Insights" element={<Insights />} />
          <Route path="FAQs" element={<FAQs />} />
          <Route path="Registration" element={<Registration />} />
          {/*  Sub pages */}
          <Route path="/Sub-Pages/CQC_Services" element={<CQC_Services />} />
          <Route path="/Sub-Pages/Care_Home" element={<Care_Home />} />
          <Route
            path="/Sub-Pages/Capital_Allowance"
            element={<Capital_Allowance />}
          />
          <Route path="/Sub-Pages/Accounting" element={<Accounting />} />
          <Route path="/Sub-Pages/Software/" element={<Software />} />
          <Route
            path="/Sub-Pages/Operational_Management/"
            element={<Operational_Management />}
          />

          {/*  Blogs  pages */}
          <Route
            path="/Blogs-Pages/Blog_Registration/"
            element={<Blog_Registration />}
          />
          <Route
            path="/Blogs-Pages/Blog_CompGuide/"
            element={<Blog_CompGuide />}
          />
          <Route
            path="/Blogs-Pages/Blog_Beginners/"
            element={<Blog_Beginners />}
          />
          <Route
            path="/Blogs-Pages/Blog_Business/"
            element={<Blog_Business />}
          />
          <Route
            path="/Blogs-Pages/Blog_Compliance/"
            element={<Blog_Compliance />}
          />
          <Route
            path="/Blogs-Pages/Blog_DocNeeded/"
            element={<Blog_DocNeeded />}
          />
          <Route
            path="/Blogs-Pages/Blog_GuideSteps/"
            element={<Blog_GuideSteps />}
          />
          <Route
            path="/Blogs-Pages/Blog_RegManager/"
            element={<Blog_RegManager />}
          />

          <Route path="Blogs-Pages/Blog_RegTake/"
           element={<Blog_RegTake />} />
          
          <Route path="/Blogs-Pages/Blog_Capital_Allowance/"
            element={<Blog_Capital />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;